import React from 'react';

export const NAV_ITEMS = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: <img src="/dashboard.svg" alt="Dashboard" className="w-8 h-8" />,
    navicon: <img src="/dashboard.svg" alt="Dashboard" className="w-6 h-6" />,
    activeIcon: <img src="/dashboard.svg" alt="Dashboard Active" className="w-8 h-8" />
  },
  
  {
    path: '/identity-management',
    name: 'Identity Management',
    icon: <img src="/code.svg" alt="Identity Management" className="w-8 h-8" />,
    navicon: <img src="/code.svg" alt="Identity Management" className="w-6 h-6" />,
    activeIcon: <img src="/code.svg" alt="Identity Management Active" className="w-8 h-8" />
  },
  {
    path: '/manage-scans',
    name: 'Manage Scans',
    icon: <img src="/database.svg" alt="Manage Scans" className="w-8 h-8" />,
    navicon: <img src="/database.svg" alt="Manage Scans" className="w-6 h-6" />,
    activeIcon: <img src="/database.svg" alt="Manage Scans Active" className="w-8 h-8" />
  },
  // {
  //   path: '/intel',
  //   name: 'Intel',
  //   icon: <img src="/database.svg" alt="Intel" className="w-8 h-8" />,
  //   navicon: <img src="/database.svg" alt="Intel" className="w-6 h-6" />,
  //   activeIcon: <img src="/database.svg" alt="Intel Active" className="w-8 h-8" />
  // },
  {
    path: '/settings',
    name: 'Configuration',
    icon: <img src="/settings.svg" alt="Settings" className="w-8 h-8" />,
    navicon: <img src="/settings.svg" alt="Settings" className="w-6 h-6" />,
    activeIcon: <img src="/settings.svg" alt="Settings Active" className="w-8 h-8" />
  },
 
];
